import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { HeaderProps } from '../../shared/Types';
import './Header.scss';

export default class Header extends Component<HeaderProps> {
  constructor(props: HeaderProps) {
    super(props);
  }

  render() {
    return (
      <header className="header">
        <nav className="header__nav">
          <h1>{this.props.page}</h1>
          <ul className="header__menu">
            <li>
              <NavLink to={'/'} className="header__link" data-testid="home">
                Home
              </NavLink>
            </li>
            <li>
              <NavLink to={'/about'} className="header__link" data-testid="about">
                About us
              </NavLink>
            </li>
            <li>
              <NavLink to={'/form'} className="header__link" data-testid="form">
                Form
              </NavLink>
            </li>
          </ul>
        </nav>
      </header>
    );
  }
}
